import {useEffect} from 'react';

const OpenApp = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const exceptionId = params.get('id');
        const exceptionType = params.get('type') || 'ManageException';
        if (!exceptionId) {
            return;
        }

        const appUrl =`valuelogistics://${exceptionType}/${exceptionId}`;
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);

        const storeUrl = isIOS
            ? 'https://testflight.apple.com/join/ssn7ceH1'
            : 'https://play.google.com/store/apps/details?id=com.valueLogistics.app';

        // Try opening the mobile app
        window.location.href = appUrl;

        // If app does not open, redirect to store
        const timer = setTimeout(() => {
            window.location.href = storeUrl;
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div style={{textAlign:'center'}}>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom:'10px',
                    marginTop:'100px'
                }}
            >
                <img
                    src={process.env.REACT_APP_VL_LOGO_URL}
                    alt="Logo"
                    style={{
                        maxWidth: '300px',
                        height: 'auto',
                    }}
                />
            </div>
            <h3>Opening VL Broker...</h3>
            <p>
                Please wait while we open the VL Broker app.
            </p>
        </div>
    );
};

export default OpenApp;